import React from 'react';

// En-tête sobre de l'app : navigation minimale, identique en esprit aux fiches SEO
// (Dictionnaire · Test de niveau), plus la bascule imprimerie/cursive et la série.
// L'app EST l'accueil (le quiz), donc pas de lien « Accueil » ici. Aucun mot-marque.

// `owner` (optionnel) : raccourci vers l'espace PERSONNEL. Il n'est rendu que si
// le serveur a reconnu le compte comme propriétaire (cf. /api/account/me). Les
// autres visiteurs n'ont simplement pas ce nœud dans le DOM.
//
// À noter, sans se raconter d'histoires : le bundle JS est public et le même pour
// tous, donc un curieux qui le lit verra qu'un espace perso existe. Ce n'est pas
// grave, et c'est pour ça qu'on n'a pas bricolé de « geste secret » (raccourci
// clavier, zone cachée) : ce serait tout aussi lisible dans le code, en plus
// pénible à utiliser. La vraie protection n'est pas de cacher la porte, c'est
// qu'elle soit verrouillée : sans être propriétaire, /?ecoute renvoie 403 et
// redirige vers l'accueil.
export default function Header({ lang, cursive, toggleCursive, owner }) {
  // `py-3 -my-3` : la zone tappable passe de 18 px à ~42 px, mais la marge négative
  // annule ce padding dans le calcul du flex, donc l'entête garde exactement la même
  // hauteur. Au doigt, ces liens étaient trop petits (recommandation : ~44 px).
  const link = 'text-xs text-slate-400 hover:text-slate-200 transition-colors py-3 -my-3';
  return (
    <div className="flex items-center justify-end gap-4">
      <a href="/" className={link}>{lang.ui.home}</a>
      <a href={`/mot/${lang.apiLang}/`} className={link}>{lang.ui.wordList}</a>
      {/* Vers la page d'EXPLICATION (statique, indexable), pas vers le moteur :
          c'est elle qui présente le test et porte le bouton de lancement. Elle
          pointait sur /?test, une URL que Google canonicalise vers l'accueil, donc
          ce lien était perdu et la page restait orpheline. */}
      <a href={lang.ui.levelTest.pagePath} className={link}>{lang.ui.levelTest.linkLabel}</a>
      {owner && (
        <a href="/?ecoute" title="Compréhension orale" aria-label="Compréhension orale"
           className="text-sm text-slate-500 hover:text-blue-300 transition-colors py-3 -my-3">
          🎧
        </a>
      )}
      <button
        onClick={toggleCursive}
        lang="ru"
        title={lang.ui.cursiveToggle}
        className={`text-sm transition-colors py-3 -my-3 ${cursive ? 'text-blue-300' : 'text-slate-500 hover:text-slate-300'}`}
      >
        Аа
      </button>
    </div>
  );
}
